@if (data.masshanteringArbetsorder) {
  <div class="modal-body">
    <div class="row">
      <rask-selector
        class="col-4"
        label="Tidsättning"
        aid="intent"
        [values]="intents"
        [(ngModel)]="intent"
        [viewFormatter]="intentViewFormatter"
        [viewSelectedFormatter]="intentViewFormatter"
        [formatter]="intentSelectedFormatter"
        (change)="onIntentChanged($event)"
        [showHeader]="true">
      </rask-selector>
      <rask-selector
        class="col-4"
        label="Maskinlag"
        aid="maskinlag"
        [values]="minaMaskinlag"
        [viewFormatter]="maskinlagViewFormatter"
        (change)="onMaskinlagChanged()"
        [(ngModel)]="selectecMaskinLag"
        [showHeader]="true"
        [disabled]="isMaskinlagDisabled">
      </rask-selector>
      <rask-datepicker
        class="col-4"
        label="Månad"
        aid="periodsattPeriodDatum"
        [(ngModel)]="periodsattPeriod"
        [minDate]="periodsattPeriodMinDate"
        [onlyMonths]="true"
        [disabled]="isTidssattningDisabled">
      </rask-datepicker>
    </div>
    <div class="row row-padding">
      <rask-selector
        class="col-4"
        label="Produktionsmall"
        bindLabel="benamning"
        (change)="onProduktionsmallChanged($event)"
        [(ngModel)]="selectedProduktionsmall"
        [values]="produktionsmallar"
        [showHeader]="true">
        <ng-container header>
          <div class="custom-highlight">
            <a [routerLink]="['minaproduktionsmallar']" target="_blank">Mina produktionsmallar <i class="far fa-external-link" aria-hidden="true"></i></a>
          </div>
        </ng-container>
      </rask-selector>
    </div>
    <div class="row row-padding">
      <div class="col-12 list-wrapper">
        <rask-div-list #arbetsorderList [data]="data.masshanteringArbetsorder" [fixedHeader]="true" [rowDrag]="true">
          <rask-list-column header="Arbetsorder" width="360px">
            <ng-template let-row="row">
              <rask-arbetsorder-info-icon [arbetsorder]="row" [useImage]="true"></rask-arbetsorder-info-icon>
              @if (row.isVirkeskop) {
                <i class="far fa-sm fa-handshake" aria-hidden="true">
                  <span class="vk-text mx-1">{{ row.affarsform }}</span>
                </i>
              }
              <span [ngClass]="{'strike-through': canSave() && !row.applicable}">{{ row.beteckning }} {{ row.namn }}</span>
            </ng-template>
          </rask-list-column>
          <rask-list-column header="Planerat maskinlag">
            <ng-template let-row="row">
              <span [ngClass]="{'strike-through': canSave() && !row.applicable}">{{ getMaskinlagName(row.planeratMaskinlagId) }}</span>
            </ng-template>
          </rask-list-column>
          <rask-list-column header="Planerad tid">
            <ng-template let-row="row">
              <span [ngClass]="{'strike-through': canSave() && !row.applicable}">{{ getArbetsorderPeriod(row) }}</span>
            </ng-template>
          </rask-list-column>
          <rask-list-column header="Nytt maskinlag">
            <ng-template let-row="row">
              <rask-selector
                [showHeader]="false"
                [values]="row.maskinlag"
                [(ngModel)]="row.nyttMaskinlagId"
                [viewFormatter]="maskinlagViewFormatter"
                [formatter]="maskinlagSelectionFormatter"
                [disabled]="row.isLocked || isMaskinlagDisabled">
              </rask-selector>
            </ng-template>
          </rask-list-column>
        </rask-div-list>
      </div>
    </div>
  </div>
}
<div class="modal-footer">
  <rask-button aid="buttonSpara" color="primary" (click)="save()" [disabled]="!canSave()">Spara</rask-button>
  <rask-button aid="buttonAvbryt" color="secondary" (click)="dismiss()" ngbAutofocus>Avbryt</rask-button>
</div>
